import { render } from "./Punishments.vue?vue&type=template&id=1be3991c&scoped=true"
import script from "./Punishments.vue?vue&type=script&lang=js"
export * from "./Punishments.vue?vue&type=script&lang=js"

import "./Punishments.vue?vue&type=style&index=0&id=1be3991c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be3991c"]])

export default __exports__